import React, { } from "react";
import { IoEyeSharp } from "react-icons/io5";
import BrandComponents from "../Masters/Brand/BrandComponents";


function ImageTable() {
  let header = [
    { label: "Id", field: "id" },
    { label: "Title", field: "title" },
    { "label": "Action", "field": <IoEyeSharp className="indexeye"/> }
  ];
  const sumofkeys = [{ first: "staffname" }];

  return (
    <div>
    <BrandComponents
      // head={header}
      // title={"IMAGE LIST"}
      // axiostabledata={"drawing/page"}
      // Add={"UPLOAD IMAGE"}
      // Create={"/imageupload"}
      // Edit={"/imageView"}
      // View={"/imageView"}
      // Sumofkeys={sumofkeys}
      header={header}
      tableTitle={"IMAGE LIST"}
      apiField={"drawing"}
      addButton={"+ ADD"}
      createRoute={"/imageupload"}
      updateRoute={"/imageView"}
      viewRoute = {"/imageView"}
    />
    </div>
  );
}

export default ImageTable;
